import React, { useEffect, useState } from 'react'
import './profile.css'
import HttpClient from '../../utils/HttpClient'
import { ImEye, ImEyeBlocked } from 'react-icons/im'
import toast from 'react-hot-toast'

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "5px",
    fontWeight: "bold"

}

const Profile = () => {

    const [first, setfirst] = useState({ username: "", useremail: "", userphone: "", password: "" })
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setfirst(prev => ({ ...prev, [name]: value }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = {
            "name": first?.username,
            "email": first?.useremail,
            "phoneNo": first?.userphone,
            "password": first?.password

        }
        if (!first?.username || !first?.useremail || !first?.password || !first?.userphone) {
            return toast?.error("Please fill all the fields")
        }
        else {
            const res = await HttpClient.requestData("update-profile", "PUT", data)
            if (res && res?.status) {
                toast.success("Updated Succesfully")
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            }
            else {
                toast.error(res?.message)
            }
        }
    }

    const viewProfile = async () => {
        const res = await HttpClient.requestData('view-profile', 'GET')
        if (res && res?.status) {
            setfirst(prev => ({ ...prev, username: res?.data?.name, useremail: res?.data?.email, userphone: res?.data?.phoneNo, password: "" }));

        }
    }

    useEffect(() => {
        viewProfile()
    }, [])

    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">
                <div className="container">
                    <div style={headLineStyle} className="page-headline">
                        Admin Profile
                    </div>
                    <div className="row">
                        <div className="col-md-6 offset-md-3">
                            <div className="card my-1">
                                <form className="card-body cardbody-color p-lg-5">
                                    <div className="text-center">
                                        <img
                                            src="https://t3.ftcdn.net/jpg/05/03/57/70/240_F_503577073_y4ZwKcQttFbUut0A7InyK8LhS3ObKL2t.jpg"
                                            className="img-fluid profile-image-pic img-thumbnail rounded-circle my-3"
                                            width="200px"
                                            alt="profile"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="Username"
                                            aria-describedby="emailHelp"
                                            placeholder="User Name"
                                            name="username"
                                            value={first?.username}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="UserEmail"
                                            aria-describedby="emailHelp"
                                            placeholder="User Email"
                                            name="useremail"
                                            value={first?.useremail}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="UserPhoneNumber"
                                            aria-describedby="emailHelp"
                                            placeholder="User Phone Number"
                                            name="userphone"
                                            value={first?.userphone}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>
                                    <div className="mb-3 position-relative">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            id="password"
                                            placeholder="Password"
                                            name="password"
                                            value={first?.password}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-link position-absolute end-0 top-50 translate-middle-y toggle-password"
                                            onClick={togglePasswordVisibility}
                                        >
                                            {showPassword ? <ImEyeBlocked /> : <ImEye />
                                            }
                                        </button>
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-color px-5 mb-5 w-100" onClick={(e) => handleSubmit(e)}>
                                            Update
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile